import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {FormattedDate} from '@pb/kit-component-formatters';

import {
    userConferencesConferenceDataSelector,
    userConferencesConferenceResultSelector,
} from '../../slices/user-conferences-conference.slice';

type Props = {
    accountId: number,
};

export const ConferenceEndDateCell = ({accountId}: Props) => {
    const {isLoading, loadingError} = useSelector(userConferencesConferenceDataSelector);
    const result = useSelector(userConferencesConferenceResultSelector);

    const conferenceEnds = useMemo(() => {
        if (!result?.data[accountId]) {
            return undefined;
        } else {
            return result?.data[accountId].endDate;
        }
    }, [result, accountId]);

    if (isLoading || loadingError || !conferenceEnds) {
        return null;
    }

    return (
        <span>
            {FormattedDate.format({value: conferenceEnds, format: 'MMM-DD-YYYY'})}
        </span>
    );
};
